<template>
  <div class="latest-news" :class="this.className">
    <div
      class="bg-left"
      :style="{ backgroundImage: 'url(' + require(`@/assets/img/latest-bg.jpg` ) + ')' }"
    ></div>
    <div
      class="bg-right"
      :style="{ backgroundImage: 'url(' + require(`@/assets/img/latest-bg-right.jpg` ) + ')' }"
    >
      <div class="blur"></div>
    </div>
    <div class="bg-line container"></div>
    <div class="container">
      <div class="title-invisible">
        <h4 class="title white">{{this.title}}</h4>
        <app-show-more :info="info" class="orange" :class="info.class"></app-show-more>
      </div>
    </div>
    <div class="content container">
      <template v-if="!mobile">
        <div class="news-list vertical" :item="news">
          <app-news v-for="item in news" :item="item" :key="item.id"></app-news>
        </div>
        <div class="alone">
          <app-news v-if="videoNews != false" :item="videoNews"></app-news>
        </div>
      </template>
      <template v-else>
        <swiper :options="newsOptions" ref="mySwiper">
          <swiper-slide v-for="newsM in newsMobile" :key="newsM.id">
            <app-news :item="newsM"></app-news>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination news-slider" slot="pagination"></div>
      </template>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Show_more from "./Show_more";
import News from "./News";

const url = process.env.VUE_APP_URL;

export default {
  props: {
    className: {
      type: String,
      default: "latest-news",
    },
    title: {
      typу: String,
      default: "latest news",
    },
  },
  data() {
    return {
      info: {
        url: "/news",
        class: "rect",
      },
      newsOptions: {
        slidesToShow: 1,
        spaceBetween: 15,
        //loop: true,
        dots: true,
        arrows: false,
        speed: 1500,
        easing: "cubic-bezier(.6,0,.22,1)",
        pagination: {
          el: ".news-slider",
          dynamicBullets: true,
          dynamicMainBullets: 3,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        },
      },
    };
  },
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    news() {
      return this.$store.getters.news.slice(0, 2);
    },
    newsMobile() {
      return this.$store.getters.news.slice(0, 6);
    },
    videoNews() {
      var videoNews = false;
      var mas = this.$store.getters.news.slice(2);
      mas.map((el) => {
        if (el.category.name == "Video") {
          videoNews = el;
          return;
        }
      });
      return videoNews;
    },
  },
  methods: {
    setNews() {
      this.axios
        .get(url + "/articles", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("setNews", payload);
        });
    },
  },
  mounted() {
    this.setNews();
  },
  components: {
    swiper,
    swiperSlide,
    "app-news": News,
    "app-show-more": Show_more,
  },
};
</script>
<style lang="scss" scoped>
.latest-news {
  position: relative;
  background-color: #283891;
  min-height: 63rem;
  padding: 8.5rem 0 9.5rem;
  &.news-page {
    height: 62rem;
    padding: 9.5rem 0 9.5rem;
    @media only screen and (max-width: 768px) {
      height: auto;
      padding: 6.5rem 0 7.5rem;
    }
    h4.title {
      margin-bottom: 6rem;
      @media only screen and (max-width: 768px) {
        margin-bottom: 4rem;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    padding: 6.5rem 0 7.5rem;
    width: 100%;
    height: auto;
  }
  .show-more {
    margin-bottom: 4rem;
  }
  &.news-page {
    .show-more {
      display: none;
    }
  }
  .news-list.vertical {
    @media only screen and (max-width: 768px) {
      width: 100%;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }
  }
  .content {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    @media only screen and (max-width: 768px) {
      width: auto;
      margin: 0 0 0 15px;
      padding-right: 5rem;
    }
  }
  .container:not(.bg-line) {
    position: relative;
    z-index: 2;
  }
  .bg-left {
    position: absolute;
    top: 0;
    left: 0;
    width: calc((100vw - 117rem) / 2 + 117rem / 3);
    height: 100%;
    //background-image: url("./../src/assets/img/latest-bg.png");
    background-size: cover;
    z-index: 1;
    @media only screen and (max-width: 1199px) {
      width: calc((100vw - 105rem) / 2 + 105rem / 3);
    }
    @media only screen and (max-width: 992px) {
      width: calc((100vw - 75rem) / 2 + 75rem / 3);
    }
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
    &:after {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      width: 100%;
      height: 100%;
      background: linear-gradient(
        270.11deg,
        #0a0736 0.05%,
        rgba(30, 27, 68, 0.864583) 51.52%,
        rgba(38, 34, 98, 0.03) 162.05%
      );
      opacity: 0.9;
    }
  }
  .bg-right {
    position: absolute;
    top: 0;
    right: 0;
    width: calc(100vw - ((100vw - 117rem) / 2 + 117rem / 3));
    height: 100%;
    //background-image: url("./../src/assets/img/latest-bg-right.png");
    background-size: cover;
    z-index: 1;
    overflow: hidden;
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        316.81deg,
        #0a0736 0.36%,
        rgba(30, 27, 68, 0.864583) 18.11%,
        rgba(38, 34, 98, 0.03) 56.23%
      );
      opacity: 0.7;
      transform: rotate(-180deg);
      content: "";
    }
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        316.81deg,
        #0a0736 0.36%,
        rgba(30, 27, 68, 0.864583) 18.11%,
        rgba(38, 34, 98, 0.03) 56.23%
      );
      opacity: 0.7;
      content: "";
    }
    .blur {
      position: absolute;
      top: 0;
      right: 21%;
      bottom: -10%;
      width: 120%;
      content: "";
      background: -o-linear-gradient(
        3deg,
        #15224e 61.2%,
        rgba(21, 34, 78, 0.4) 76.63%,
        rgba(21, 34, 78, 0.1) 88.51%,
        rgba(21, 34, 78, 0) 99.41%
      );
      background: linear-gradient(
        87deg,
        #15224e 61.2%,
        rgba(21, 34, 78, 0.4) 76.63%,
        rgba(21, 34, 78, 0.1) 88.51%,
        rgba(21, 34, 78, 0) 99.41%
      );
      opacity: 0.8;
      -webkit-filter: blur(100px);
      filter: blur(100px);
      //-webkit-backdrop-filter: blur(250px);
      //backdrop-filter: blur(250px);
    }
    @media only screen and (max-width: 1199px) {
      width: calc(100vw - ((100vw - 105rem) / 2 + 105rem / 3));
    }
    @media only screen and (max-width: 992px) {
      width: calc(100vw - ((100vw - 75rem) / 2 + 75rem / 3));
    }
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }
}
</style>